import { render, staticRenderFns } from "./HistLwOrders.vue?vue&type=template&id=850d4836"
import script from "./HistLwOrders.vue?vue&type=script&lang=js"
export * from "./HistLwOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports